import { useMutation } from '@apollo/client';

import type { LEARNING_GOAL_OPTIONS_TYPE } from 'bundles/onboarding-common/constants';
import LearnerObjectUpdateLearningGoal from 'bundles/onboarding-common/queries/LearnerObjectUpdateLearningGoal.graphql';
import type {
  LearnerObject_UpdateLearningGoalMutation as LearnerObjectUpdateLearningGoalMutation,
  LearnerObject_UpdateLearningGoalMutationVariables as LearnerObjectUpdateLearningGoalMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateLearningGoal';
import { formatLearningGoalForLearnerObject } from 'bundles/onboarding-common/utils/userProfileUtils';

const useLearnerObjectUpdateLearningGoal = () => {
  const [learnerObjectUpdateLearningGoalMutation] = useMutation<
    LearnerObjectUpdateLearningGoalMutation,
    LearnerObjectUpdateLearningGoalMutationVariables
  >(LearnerObjectUpdateLearningGoal, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateLearningGoal = async (learningGoal: LEARNING_GOAL_OPTIONS_TYPE) => {
    const variables: LearnerObjectUpdateLearningGoalMutationVariables = {
      input: {
        learningGoal: formatLearningGoalForLearnerObject(learningGoal),
      },
    };

    const { errors, data } = await learnerObjectUpdateLearningGoalMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerObject_UpdateLearningGoal.__typename === 'LearnerObject_UpdateLearningGoalResultError') {
      return {
        success: false,
        errors: [data.LearnerObject_UpdateLearningGoal.message],
      };
    }

    return { success: true, errors: [] };
  };

  return {
    updateLearningGoal,
  };
};

export default useLearnerObjectUpdateLearningGoal;
